export const API_PREFIX = 'api';
export const STORAGE_PREFIX = 'storage';

export const API_VERSIONS = {
  v1: 'v1',
};

export const IPX_WEBP_IMAGE_PREFIX = '/_ipx/f_webp';
export const IPX_WEBP_IMAGE_PATH = `${IPX_WEBP_IMAGE_PREFIX}/images`;
